import React, { useState } from "react";
import { useI18n } from "@/lib/i18n";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-charcoal py-24 lg:py-40">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-4">
          <div className="eyebrow mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-brass" /> {t.faq.eyebrow}
          </div>
          <h2 className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl text-bone leading-[1] tracking-tight">
            {t.faq.title_1} <span className="italic-display text-brass">{t.faq.title_2}</span>
          </h2>
        </div>

        <div className="col-span-12 lg:col-span-7 lg:col-start-6">
          <div className="border-t border-bone/10">
            {t.faq.list.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b border-bone/10" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="font-display text-xl lg:text-2xl text-bone tracking-tight group-hover:text-brass transition-colors">{f.q}</span>
                    <span className={`shrink-0 w-9 h-9 grid place-items-center border transition-all duration-500 ${isOpen ? "border-brass text-brass rotate-180" : "border-bone/20 text-bone/60"}`}>
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </button>
                  <div className={`grid transition-all duration-500 ease-editorial ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="pb-6 pr-12 text-bone/70 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
